import { render } from "./AccPurchase.vue?vue&type=template&id=74de2a12"
import script from "./AccPurchase.vue?vue&type=script&lang=js"
export * from "./AccPurchase.vue?vue&type=script&lang=js"
script.render = render

export default script